import React from "react";
import { Box, ListItem, ListItemButton, TextField, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import styled from "styled-components";
import { ActiveDate } from "src/scenes/dashboard/date-provider";
import { useSprints } from "src/scenes/dashboard/selected-sprint-provider";
import { useAuth } from "src/components/providers/auth-context";
import { format, isAfter, subMonths } from "date-fns";
import List from "@mui/material/List";
import { useTeamSprints } from "src/scenes/teams/dashboard/selected-sprints-provider-teams";

const DateText = styled.p`
    font-size: 10px;
    margin: 0;
    opacity: 0.6;
`;
const SprintPickerModal = ({ handleClose, isTeams }) => {
    const [searchQuery, setSearchQuery] = React.useState("");
    const { handleChange } = React.useContext(ActiveDate);
    const { isDemo } = useAuth();
    const { allSprints, handleSprintChange } = isTeams ? useTeamSprints() : useSprints();
    const { isUserPayingCustomer } = useAuth();
    const [sprintData, setSprintData] = React.useState([]);

    const handleSearchInput = (event) => {
        if (event.target.value === "") {
            setSearchQuery(null);
        } else {
            setSearchQuery(event.target.value);
        }
    };

    React.useEffect(() => {
        let tempData = [...allSprints];
        if (searchQuery)
            tempData = allSprints.filter((team) =>
                team.name.toLowerCase().includes(searchQuery.toLowerCase())
            );
        setSprintData(tempData);
    }, [searchQuery, allSprints]);

    if (!sprintData) return null;
    return (
        <Stack direction="column" padding={2} style={{ maxHeight: "50vh" }}>
            <p>Select a sprint</p>
            <TextField
                onChange={handleSearchInput}
                type="search"
                id="search-teams"
                size="small"
                label={
                    <Typography sx={{ fontSize: 12, paddingTop: "3px" }}>Search Sprints</Typography>
                }
                variant="outlined"
            />
            <Box
                sx={{
                    width: "100%",
                    height: "300px",
                    overflowX: "auto",
                    paddingBottom: "12px",
                    marginTop: "12px",
                }}
            >
                <List dense>
                    {!isUserPayingCustomer &&
                        !isDemo &&
                        sprintData.map((option) => (
                            <ListItemButton
                                key={option.id}
                                disabled={isAfter(
                                    new Date(subMonths(new Date(), 3).toISOString()),
                                    new Date(option.startDate)
                                )}
                                onClick={() => {
                                    handleChange(
                                        new Date(option.startDate),
                                        new Date(option.endDate)
                                    );
                                    handleSprintChange(option.name);
                                    handleClose();
                                }}
                            >
                                <ListItem key={option.id} value={option}>
                                    <Stack direction="column">
                                        {option.name}
                                        <Stack direction="row">
                                            <DateText>
                                                {format(new Date(option.startDate), "d MMM y")} -{" "}
                                                {format(new Date(option.endDate), "d MMM y")}
                                            </DateText>
                                        </Stack>
                                    </Stack>
                                </ListItem>
                            </ListItemButton>
                        ))}
                    {(isUserPayingCustomer || isDemo) &&
                        sprintData.map((option) => (
                            <ListItemButton
                                key={option.id}
                                onClick={() => {
                                    handleChange(
                                        new Date(option.startDate),
                                        new Date(option.endDate)
                                    );
                                    handleSprintChange(option.name);
                                    handleClose();
                                }}
                            >
                                <ListItem key={option.id} value={option}>
                                    <Stack direction="column">
                                        {option.name}
                                        <Stack direction="row">
                                            <DateText>
                                                {format(new Date(option.startDate), "d MMM y")} -{" "}
                                                {format(new Date(option.endDate), "d MMM y")}
                                            </DateText>
                                        </Stack>
                                    </Stack>
                                </ListItem>
                            </ListItemButton>
                        ))}
                </List>
            </Box>
        </Stack>
    );
};

export default SprintPickerModal;
